import { Directive, Input,  } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import moment from 'moment';

@Directive({
  selector: '[maxDate]',
  providers: [{provide: NG_VALIDATORS, useExisting: MaxDateDirective, multi: true}]
})
export class MaxDateDirective implements Validator {

  constructor() { }

  @Input() maxDate?:Date;

  validate(control: AbstractControl): ValidationErrors | null {

    const value = control.value;
    if ((value||'')==''){
      return null;
    }
    if (!this.maxDate) return null;
      if (moment(value).isAfter(this.maxDate)){        
        return {'Errors/maxDate':'La date doit être inférieure ou égale à ' + moment(this.maxDate).format('DD/MM/YYYY')};
      }
      return null;
  }
}
